import { FieldOperationConfigInput } from '@indigohive/cogfy-types'
import { Button } from '../../../Button'
import { CaseUpperIcon } from 'lucide-react'

export type DynamicInputButtonProps = {
  input?: FieldOperationConfigInput
  onClick?: () => void
}

export function DynamicInputButton (props: DynamicInputButtonProps) {
  const { input, onClick } = props

  return (
    <Button
      square
      ghost
      size="sm"
      className={input?.type === 'text' ? 'text-slate-400' : ''}
      onClick={onClick}
    >
      <CaseUpperIcon size={20} />
    </Button>
  )
}
